const name = 'BaseScale';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, params = {}) {
    return kit.engine.tween(elements, { duration, delay, ...params }, [
        'scale',
        'scaleX',
        'scaleY',
    ]);
}
export { name, properties, animate };
//# sourceMappingURL=baseScale.js.map